import Scrollbar from 'src/components/scrollbar';
import Iconify from 'src/components/iconify';
import Image from 'src/components/image';
import { NAV } from 'src/layouts/config-layout';
// @mui
import { Box, Stack, Button } from '@mui/material';
import SvgColor from 'src/components/svg-color';
import { useSnackbar } from 'notistack';
import { useJobCreationContext } from '../../hooks/use-job-creation-context';

export default function JobCreationNavbar() {
  // hooks
  const { currentState, jobDetails, setCurrentState, JOB_CREATION_STATES } =
    useJobCreationContext();
  const { enqueueSnackbar } = useSnackbar();

  return (
    <Box
      component="nav"
      bgcolor={theme => theme.palette.background.primaryGrey1}
      sx={{
        flexShrink: 0,
        width: NAV.W_VERTICAL,
      }}
    >
      <Stack
        sx={{
          height: 1,
          position: 'fixed',
          width: NAV.W_VERTICAL,
          paddingTop: '130px',
          paddingRight: '48px',
          paddingLeft: '12px',
        }}
      >
        <Scrollbar
          sx={{
            height: 1,
          }}
        >
          <Stack spacing={4}>
            <Stack spacing={1}>
              <Stack alignItems="center" spacing={1}>
                <Button
                  fullWidth
                  sx={{
                    justifyContent: 'start',
                    px: '14px',
                    py: '8px',
                    background: theme =>
                      currentState === JOB_CREATION_STATES.JOB_DETAILS.value
                        ? theme.palette.background.primaryAccent2
                        : theme.palette.background.primaryGrey1,
                    '&:hover': {
                      background: theme =>
                        theme.palette.background.primaryGrey2,
                    },
                  }}
                  startIcon={
                    <Image
                      src="/assets/icons/job/ic_job_details.svg"
                      alt="job-details"
                    />
                  }
                  onClick={() =>
                    setCurrentState(JOB_CREATION_STATES.JOB_DETAILS.value)
                  }
                >
                  Job Requirements
                </Button>
                <Button
                  fullWidth
                  sx={{
                    justifyContent: 'start',
                    px: '14px',
                    py: '8px',
                    background: theme =>
                      currentState ===
                      JOB_CREATION_STATES.AUTOPILOT_WORKFLOW.value
                        ? theme.palette.background.primaryAccent2
                        : theme.palette.background.primaryGrey1,
                    '&:hover': {
                      background: theme =>
                        theme.palette.background.primaryGrey2,
                    },
                  }}
                  startIcon={
                    <SvgColor src="/assets/icons/job/ic_autopilot_workflow.svg" />
                  }
                  onClick={() => {
                    if (jobDetails)
                      setCurrentState(
                        JOB_CREATION_STATES.AUTOPILOT_WORKFLOW.value,
                      );
                    else
                      enqueueSnackbar({
                        message: 'Please fill in the job details first',
                        variant: 'error',
                      });
                  }}
                >
                  Autopilot Setup
                </Button>
                <Button
                  fullWidth
                  sx={{
                    justifyContent: 'start',
                    px: '14px',
                    py: '8px',
                    background: theme =>
                      currentState === JOB_CREATION_STATES.LAUNCH.value
                        ? theme.palette.background.primaryAccent2
                        : theme.palette.background.primaryGrey1,
                    '&:hover': {
                      background: theme =>
                        theme.palette.background.primaryGrey2,
                    },
                  }}
                  startIcon={<Iconify icon="tabler:rocket" />}
                  onClick={() => {
                    if (jobDetails)
                      setCurrentState(JOB_CREATION_STATES.LAUNCH.value);
                    else
                      enqueueSnackbar({
                        message: 'Please fill in the job details first',
                        variant: 'error',
                      });
                  }}
                >
                  Launch
                </Button>
              </Stack>
            </Stack>
          </Stack>
        </Scrollbar>
      </Stack>
    </Box>
  );
}

JobCreationNavbar.propTypes = {};
